import cx from 'clsx';

import { InfoCircleFillIcon } from '@autopass-web/mochi-icons';
import { PAYMENT_METHODS_INFO } from '@autopass-web/mochi-payment-module';

import { Block } from '../../../../components';
import { checkIsApplePaySupported } from '../../utils';
import styles from './methods.module.scss';

import type { PaymentMethodTypes } from '@autopass-web/mochi-payment-module';
import type { MouseEventHandler, ReactNode } from 'react';

export type AvailMethods = Array<{
  value: PaymentMethodTypes;
  available: boolean;
}>;

const CreditCardIcon = PAYMENT_METHODS_INFO['credit_card'].Icon;

const CreditCardBlock = ({
  onClick,
  className,
}: {
  onClick: MouseEventHandler<HTMLLIElement>;
  className: string;
}) => {
  return (
    <li className={cx(styles['credit_card'], className)} onClick={onClick}>
      <div>
        {<CreditCardIcon />}
        信用卡/簽帳金融卡
      </div>
      <div>使用指定銀行信用卡優惠</div>
    </li>
  );
};

export const Methods = (props: {
  availMethods: AvailMethods;
  currentMethod?: PaymentMethodTypes;
  handleMethodClick: (
    value: PaymentMethodTypes,
    event: React.MouseEvent<HTMLLIElement>,
  ) => void;
  hint: ReactNode;
}) => {
  const { availMethods, currentMethod = '', handleMethodClick, hint } = props;

  const methods = availMethods
    .filter(({ value }) => {
      return PAYMENT_METHODS_INFO[value].enabled;
    })
    .toSorted((methodA, methodB) => {
      const orderA = PAYMENT_METHODS_INFO[methodA.value].order;
      const orderB = PAYMENT_METHODS_INFO[methodB.value].order;

      return orderA - orderB;
    });

  return (
    <>
      <Block title="付款方式" className="gap-3 flex flex-col">
        <ul className={styles['options-group']}>
          {methods
            .filter((method) => {
              const isApplePaySupported = checkIsApplePaySupported();
              return method.value !== 'apple_pay' || isApplePaySupported;
            })
            .map((method) => {
              const { value: methodValue } = method;
              const className = cx(
                currentMethod === methodValue && styles['select'],
                !method.available && styles['disabled'],
                styles['option'],
              );

              if (methodValue === 'credit_card') {
                return (
                  <CreditCardBlock
                    key={methodValue}
                    className={className}
                    onClick={(e) => {
                      handleMethodClick(methodValue, e);
                    }}
                  />
                );
              }

              const Icon = PAYMENT_METHODS_INFO[methodValue].Icon;
              return (
                <li
                  className={className}
                  key={methodValue}
                  onClick={(e) => {
                    handleMethodClick(methodValue, e);
                  }}
                >
                  <Icon />
                </li>
              );
            })}
        </ul>
        {hint}
        {(currentMethod === 'auto_partner' || currentMethod === 'autopass') && (
          <div className="flex gap-1 px-2 py-3 rounded-xl bg-[#F2F8FF] text-xs mb-3">
            <div>
              <InfoCircleFillIcon className="h-[15px] w-[15px]" />
            </div>
            <div>
              此付款方式為 powered by Autopass
              提供，請注意該平台是否完成註冊、綁定與信用卡設定。
            </div>
          </div>
        )}
      </Block>
    </>
  );
};
